import type { Banner } from "@scott/ui-d2c/types";
import type React from "react";
import { useNavigationStore } from "./use-navigation-store";

export interface BannerNavProps {
  banners: Banner[];
  currentLevel: 1 | 2 | 3 | 4 | 5;
}

const BannerNav: React.FC<BannerNavProps> = ({ banners, currentLevel }) => {
  const { clearFromLevel, pushToBannerDataLayer } = useNavigationStore();

  return (
    <ul className="mt-8 max-w-80">
      {banners.map((banner, index) => (
        <li
          className="relative mb-8 bg-black"
          key={`banner-${banner.bannerName}-${index}`}
        >
          <a
            className="group block min-h-40"
            href={banner.bannerUrl}
            onClick={() => {
              clearFromLevel(currentLevel);
              pushToBannerDataLayer(banner, index);
            }}
          >
            {banner.bannerPictureUrl && (
              <img
                alt={banner.bannerName}
                className="h-auto w-full opacity-50 transition-opacity duration-500 group-hover:opacity-100"
                src={banner.bannerPictureUrl}
              />
            )}
            <div className="absolute bottom-0 p-4">
              <h2 className="mt-2 mb-1.5 text-white text-xl uppercase tracking-widest">
                {banner.bannerHeadline}
              </h2>
              <p className="text-sm text-white normal-case">
                {banner.bannerSubTitle}
              </p>
            </div>
          </a>
        </li>
      ))}
    </ul>
  );
};

export { BannerNav };
